/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coach_Form_DetrainingInputs */

const en_coach_form_detraining = /** @type {(inputs: Coach_Form_DetrainingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Detraining risk. Increase volume.`)
};

const de_coach_form_detraining = /** @type {(inputs: Coach_Form_DetrainingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formverlust droht. Zeit, wieder loszulegen.`)
};

/**
* | output |
* | --- |
* | "Detraining risk. Increase volume." |
*
* @param {Coach_Form_DetrainingInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const coach_form_detraining = /** @type {((inputs?: Coach_Form_DetrainingInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coach_Form_DetrainingInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_coach_form_detraining(inputs)
	return de_coach_form_detraining(inputs)
});